import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

export default {
	install (Vue) {
		// use a new Vue instance as the interface for Vue components to receive/send SignalR events
		// this way every component can listen to events or send new events using this.$lcrHub
		const lcrHub = new Vue()
		Vue.prototype.$lcrHub = lcrHub

		// Provide methods to connect/disconnect from the SignalR hub
		let connection = null
		let startedPromise = null
		let manuallyClosed = false

		Vue.prototype.startSignalR = (jwtToken) => {
			connection = new HubConnectionBuilder()
				.withUrl(
					process.env.VUE_APP_API_URL + '/lane-closure-request-hub',
					jwtToken ? { accessTokenFactory: () => jwtToken } : null
				)
				.configureLogging(LogLevel.Information)
				.build()

			// Forward hub events through the event, so we can listen for them in the Vue components
			connection.on('NewMessage', (message) => {
				lcrHub.$emit('hub-new-message', message)
			})
			connection.on('LiveChatMessageReceived', (username, text) => {
				lcrHub.$emit('chat-message-received', { username, text })
			})

			connection.on('Reminder', (message) => {
				lcrHub.$emit('hub-reminder', message)
			})

			connection.on('Alert', (message) => {
				lcrHub.$emit('hub-alert', message)
			})

			connection.on('NewNotification', (entry) => {
				lcrHub.$emit('new-notification', entry)
			})

			connection.on('DismissNotification', (lcrId) => {
				lcrHub.$emit('dismiss-notification', lcrId)
			})

			connection.on('DismissContraventionNotification', (contraventionId) => {
				lcrHub.$emit('dismiss-contravention-notification', contraventionId)
			})

			// You need to call connection.start() to establish the connection but the client wont handle reconnecting for you!
			// Docs recommend listening onclose and handling it there.
			// This is the simplest of the strategies
			function start () {
				startedPromise = connection.start()
					.catch(error => {
						// console.error('Failed to connect with hub', error)
						return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000))
					})
				return startedPromise
			}
			connection.onclose(() => {
				if (!manuallyClosed) start()
			})

			// Start everything
			manuallyClosed = false
			start()
		}
		Vue.prototype.stopSignalR = () => {
			if (!startedPromise) return

			manuallyClosed = true
			return startedPromise
				.then(() => connection.stop())
				.then(() => { startedPromise = null })
		}

		// Provide methods for components to send messages back to server
		// Make sure no invocation happens until the connection is established
		lcrHub.questionOpened = (questionId) => {
			if (!startedPromise) return

			return startedPromise
				.then(() => connection.invoke('JoinQuestionGroup', questionId))
				.catch(console.error)
		}
		lcrHub.questionClosed = (questionId) => {
			if (!startedPromise) return

			return startedPromise
				.then(() => connection.invoke('LeaveQuestionGroup', questionId))
				.catch(console.error)
		}
		lcrHub.sendMessage = (message) => {
			if (!startedPromise) return

			return startedPromise
				.then(() => connection.invoke('SendLiveChatMessage', message))
				.catch(console.error)
		}
	}
}
